module.exports = "/images/avatar1.jpg?ac60ef718e8f9765886e30ee907fea17";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/authors/avatar1.jpg
// module id = 28
// module chunks = 23